import { TGlobalContainerDesigns } from '@styles/design-system/global-components/global-components.types';
import { CSSProperties, PropsWithChildren } from 'react';
import { ReactFocusLockProps } from 'react-focus-lock';

export const MODAL_ANIMATION_TIME = 300;

export type CustomSizeType = {
  width?: string;
  maxWidth?: string;
  height?: string;
  maxHeight?: string;
  minHeight?: string;
  minWidth?: string;
};

type SharedModalProps = {
  onRequestClose?: () => void;
  portalClassName?: string;
  contentWrapperClassName?: string;
  contentClassName?: string;
  modalClassName?: string;
  footerClassName?: string;
  backgroundColor?: string;
  animation?: 'slide-up' | 'slide-down' | 'slide-left' | 'slide-right' | 'fade' | 'zoom' | 'rotate' | 'flip' | 'drawer';
  withZoom?: boolean;
  size?: 'small' | 'medium' | 'large' | 'full';
  showBackdrop?: boolean;
  RenderHeaderContent?: React.ComponentType;
  RenderFooterContent?: React.ComponentType;
  customSize?: CustomSizeType;
  delayContentRender?: number;
  showLoadingIndicator?: boolean;
  delayRenderLoadingIndicator?: number;
  onTransitionOpening?: () => void;
  onTransitionOpened?: () => void;
  onTransitionClosing?: () => void;
  onTransitionClosed?: () => void;
  fadeTransition?: boolean;
  transitionDuration?: number;
  transitionTimingFunction?: CSSProperties['transitionTimingFunction'];
  animateHeightTransition?: boolean;
  'data-component'?: string;
  focusLockProps?: ReactFocusLockProps;
  design?: keyof typeof TGlobalContainerDesigns;
  drawerMode?: boolean;
  onBodyScroll?: () => void;
  onBodyScrollToBottom?: () => void;
};

/**
 * Controlled: parent drives open/close via the `open` boolean prop.
 * Uncontrolled: open/close is driven entirely by events via `useModal(id)`.
 *   - `id` is required so the event channel can be identified.
 *   - `open` must not be passed — mixing the two modes causes state conflicts.
 */
export type ModalProps = PropsWithChildren<
  SharedModalProps & ({ open: boolean; id?: string } | { id: string; open?: never })
>;
